import { render, staticRenderFns } from "./yxtjfx.vue?vue&type=template&id=6137fdea&scoped=true&"
import script from "./yxtjfx.vue?vue&type=script&lang=js&"
export * from "./yxtjfx.vue?vue&type=script&lang=js&"
import style0 from "./yxtjfx.vue?vue&type=style&index=0&id=6137fdea&prod&lang=scss&"
import style1 from "./yxtjfx.vue?vue&type=style&index=1&id=6137fdea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6137fdea",
  null
  
)

export default component.exports